import Table from "../../../component/table/Table";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import {fetchDocumenti} from '../../../features/documenti/documentiThunk'
const DocumentiMezzi = () => {

  const selectSelectedCompany = useSelector((state) => state.company.selectedCompany);

    const dispatch = useDispatch(); // Dispatch hook
    const documenti = useSelector((state) => state.documenti?.documenti);
    const loading = useSelector((state) => state.documenti?.isLoading);
    const columns = [
        { field: "doc_name", headerName: "Documento", width: 596 },
        { field: "tipo_di_invento", headerName: "Tipo", width: 261 },
        { field: "scadenza", headerName: "Scadenza", width: 136 },
        // { field: "stato_intervento", headerName: "Data", width: 124 },
        { field: "stato_intervento", headerName: "Stato", width: 157 },
        { field: "azioni", headerName: "Azioni", width: 60, sortable: false }
    ];
    const [tableRows, setTableRows] = useState([]);
useEffect(() => {
      dispatch(fetchDocumenti()); // Dispatch the fetchProdotti action to get the data
  }, [dispatch, selectSelectedCompany]);

  useEffect(() => {
    // if (documenti && documenti.length > 0) {
      console.log(documenti);
      const mappedData = documenti.map((item) => ({
        id: item?.id,
        doc_name: item?.doc_name,
        tipo_di_invento: item?.tipo_di_invento,
        scadenza: item?.scadenza,
        stato_intervento: item?.stato_intervento,
      }));
      setTableRows(mappedData);
    // }
  }, [documenti]);

    return (
        <>
            <div className="pageTemplate">
                <Table
                data={tableRows}
                columns={columns}
                navData={"documentiLogistica"}
                deleteFunctions={"deleteDocumentiData"}
                />
            </div>
        </>
    );
};
export default DocumentiMezzi;